module.exports = __webpack_public_path__ + "img/256.6a60c923.png";